
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"30","height":"30"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15 28.995A14 14 0 015.1 5.1a14 14 0 1119.8 19.8 13.921 13.921 0 01-9.9 4.095zm-.4-8.529a2.173 2.173 0 101.541 3.7 2.14 2.14 0 00.632-1.528 2.176 2.176 0 00-2.173-2.173zm.291-12.253c1.6 0 2.548.852 2.548 2.28 0 1.239-1.046 2.045-2.153 2.9-1.224.943-2.489 1.919-2.489 3.575a1.685 1.685 0 001.7 1.775c1.251 0 1.5-.67 1.771-1.379a3.95 3.95 0 01.4-.85 6.153 6.153 0 011.422-1.206c1.425-1.015 3.377-2.4 3.377-4.814a4.7 4.7 0 00-2.1-4.055 8.329 8.329 0 00-4.641-1.249 7.1 7.1 0 00-4.309 1.477 4.493 4.493 0 00-1.89 3.428 1.59 1.59 0 001.724 1.618c1.2 0 1.554-.763 1.93-1.57a2.619 2.619 0 012.712-1.93z"}})])
          )
        }
      }
    